import React, { useState } from "react";
import TwoTabs from "../Tabs/TwoTabs";
import styles from "./leftsidebar.module.css";
import Clock from "../../Assets/images/clock.svg";
import TimeIcon from "../../Assets/images/time.svg";
import DoorIcon from "../../Assets/images/door.svg";
import CallIcon from "../../Assets/images/call.svg";
import PayIcon from "../../Assets/images/payment.svg";
import RefreshIcon from "../../Assets/images/refresh.svg";
import InfoIcon from "../../Assets/images/info.svg";
import CustomModal from "../Modal/CustomModal";
import { useLocation } from "react-router-dom";
import { useGlobalContext } from "../../Context/GlobalContext";
import logger from "../../Utils/logger";

const appointments = [
	{
		id: 1,
		service: "Slimming 90",
		time: "09.00 AM - 10.30 AM",
		contact: "+65 91234567",
		room: "913",
		status: "Paid",
	},
	{
		id: 2,
		service: "Body 60",
		time: "09.00 AM - 10.00 AM",
		contact: "+65 92345678",
		room: "920",
		status: "Paid",
	},
	{
		id: 3,
		service: "Foot 60",
		time: "09.00 AM - 10.00 AM",
		contact: "+65 93456789",
		room: "905",
		status: "Paid",
	},
	{
		id: 4,
		service: "Express Head Relief 15",
		time: "09.15 AM - 09.30 AM",
		contact: "+65 94567890",
		room: "Monkey 1",
		status: "Paid",
	},
	{
		id: 5,
		service: "5 in 1 [60 Mins]",
		time: "09.30 AM - 10.30 AM",
		contact: "+65 95678901",
		room: "913",
		status: "Paid",
	},
	{
		id: 6,
		service: "5 in 1 [90 Mins]",
		time: "09.30 AM - 11.00 AM",
		contact: "+65 96789012",
		room: "913",
		status: "Paid",
	},
	{
		id: 7,
		service: "Slimming 90",
		time: "10.00 AM - 11.30 AM",
		contact: "+65 97890123",
		room: "906",
		status: "Paid",
	},
	{
		id: 8,
		service: "Slimming 120",
		time: "10.00 AM - 12.00 AM",
		contact: "+65 98901234",
		room: "903",
		status: "Paid",
	},
	{
		id: 9,
		service: "Body Scrub 30",
		time: "10.30 AM - 11.00 AM",
		contact: "+65 99012345",
		room: "903",
		status: "Paid",
	},
	{
		id: 10,
		service: "Luxury Gold Ritual 30",
		time: "10.30 AM - 11.00 AM",
		contact: "+65 90123456",
		room: "Monkey 1",
		status: "Paid",
	},
];

const TherapistList = ({ gender, list = [] }) => (
	<div className={`${styles.userList} ${gender}-list`}>
		<h5>
			{gender.charAt(0).toUpperCase() + gender.slice(1)}{" "}
			<span className={styles.genderName}>({list.length})</span>
		</h5>
		<ul>
			{list.map((therapist) => (
				<li key={therapist.id} className={styles[therapist.status]}>
					<div className={styles.therapistList}>
						<p
							className={`position-relative ${
								styles[`${gender}Icon`]
							}`}>
							<span className={styles.status}></span>
						</p>
						<p className={styles.name}>{therapist.name}</p>
						{/* Display clock for 'jobWithin30Mins' */}
						{therapist.jobWithin30Mins && (
							<span className={styles.clockIcon}>
								<img src={Clock} alt="clock" />
							</span>
						)}
					</div>
				</li>
			))}
		</ul>
	</div>
);

const AppointmentList = ({ appointments }) => (
	<div className={styles.jobListing}>
		{appointments.map((appointment) => (
			<div key={appointment.id} className={styles.Card}>
				<p>{appointment.service}</p>
				<div className={styles.appointmentInfo}>
					<div className={styles.Info}>
						<img src={TimeIcon} alt="time" />
						<span>{appointment.time}</span>
					</div>
					<div className={styles.Info}>
						<img src={DoorIcon} alt="room" />
						<span>{appointment.room}</span>
					</div>
				</div>
				<div className={styles.appointmentInfo}>
					<div className={styles.Info}>
						<img src={CallIcon} alt="call" />
						<span>{appointment.contact}</span>
					</div>
					<div className={styles.Info}>
						<img src={PayIcon} alt="payment" />
						<span>{appointment.status}</span>
					</div>
				</div>
			</div>
		))}
	</div>
);

const LeftSidebar = ({ isOpen }) => {
	const { pathname } = useLocation();
	const { staffData } = useGlobalContext(); // Move inside the component
	const therapists = staffData?.staff || [];

	const formatTimeWithoutSeconds = () => {
		const now = new Date();
		return now.toLocaleTimeString([], {
			hour: "2-digit",
			minute: "2-digit",
		});
	};

	// State variables
	const [modalShow, setModalShow] = useState(false);
	const [updatedTime, setUpdatedTime] = useState(formatTimeWithoutSeconds());
	const [currentAppointments, setCurrentAppointments] =
		useState(appointments);

	const maleStaff = therapists.filter(
		(staff) => staff.gender?.toLowerCase() === "male"
	);
	const femaleStaff = therapists.filter(
		(staff) => staff.gender?.toLowerCase() === "female"
	);

	const handleRefreshClick = () => {
		logger.log("Refresh button clicked!");
		// Simulate refreshing data
		const refreshedAppointments = [...appointments]; // Fetch or modify data here
		setCurrentAppointments(refreshedAppointments);
		setUpdatedTime(formatTimeWithoutSeconds());
	};

	const tabsData = [
		{
			eventKey: "therapist",
			title: "Therapists",
			content: (
				<div className={styles.therapistListing}>
					<TherapistList gender="male" list={maleStaff} />
					<TherapistList gender="female" list={femaleStaff} />
				</div>
			),
			tabClassName: styles.navItem,
		},
		{
			eventKey: "unassignedjobs",
			title: "Unassigned Jobs (100)",
			content: (
				<div>
					<AppointmentList appointments={currentAppointments} />
				</div>
			),
			tabClassName: styles.navItem,
		},
	];

	if (pathname === "/") {
		return (
			<>
				<div className={`showSidebar ${isOpen ? "sidebarOpen" : ""}`}>
					<div className={styles.sidebar}>
						<div className={styles.refreshTime}>
							<p>
								Updated:{" "}
								<span className={styles.updateTime}>
									{updatedTime}
								</span>
							</p>
							<div>
								<button
									className={styles.infoIcon}
									onClick={() => setModalShow(true)}
									aria-label="Info">
									<img src={InfoIcon} alt="Info" />
								</button>
								<button
									className={styles.refreshIcon}
									onClick={handleRefreshClick}
									aria-label="Refresh">
									<img src={RefreshIcon} alt="Refresh" />
								</button>
							</div>
						</div>
						<TwoTabs
							defaultActiveKey="therapist"
							tabs={tabsData}
							className="navTabs"
							tabClassname={styles.homeTabs}
						/>
					</div>
					<CustomModal
						show={modalShow}
						onHide={() => setModalShow(false)}
						title="Status"
						modalId="#userInfo"
						modalClass={styles.userInfo}
						style={styles}>
						<div className={styles.busy}>
							<span className={styles.status}></span>
							<span>Busy</span>
						</div>

						<div className={styles.available}>
							<span className={styles.status}></span>
							<span>Available</span>
						</div>

						<div className={styles.onBreak}>
							<span className={styles.status}></span>
							<span>On Break</span>
						</div>

						<div className={styles.clock}>
							<span className={styles.status}>
								<img src={Clock} alt="icon" />
							</span>
							<span>Job within 30 minutes</span>
						</div>
					</CustomModal>
				</div>
			</>
		);
	} else {
		return null;
	}
};

export default LeftSidebar;
